import React, { Component } from 'react';
import './UnitListPage.css';
import Page from '../../components/page/Page';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import Input from '../../inputs/input/Input';
import Button from '../../components/button/Button';
import mainAPI from '../../api/MainAPI';
import utils from '../../utils/utils';
import models from '../../model/models';
import history from '../../history';
import DrugBoxCard from './drugBoxCard/DrugBoxCard';
import Popup from '../../components/popup/Popup';
import toasts from '../../utils/toasts';
import FormTemplate from '../../components/templates/formTemplates/FormTemplate';
import CardHeader from '../../components/cardHeader/CardHeader';
import Icon from "../../components/icon/Icon";
import ToggleSetting from "../../components/toggleSetting/ToggleSetting";
import SortableTable from "../../components/sortableTable/SortableTable";
import {Link} from "@material-ui/core";
import UpdateTitle from '../../components/updateTitle/UpdateTitle';
import FontIcon from '../../components/fontIcon/FontIcon';

class CreateUnitPopup extends FormTemplate {
	constructor(props) {
		super(props);
		this.myRefs = {};
	}

	_close = () => {
		this.props.onClose();
	};

	_save = async () => {
		let unit = this.getValue();
		if (!this.isValid()) return toasts.show('Fill out required fields');
		this._close();
		await mainAPI.unit.create(unit);
	};

	getValue = () => {
		let obj = {};
		for (let i in this.myRefs) {
			obj[i] = this.myRefs[i].getValue();
		}
		return obj;
	};

	render() {
		return (
			<Popup className="g-create-unit-popup" show={this.props.creating} onClose={this._close}>
				<Card>
					<Label larger black>
						Create Unit
					</Label>
          <div className="close-popup">
						<FontIcon
							tabIndex="0"
							onClick={this._close}
							name="icon-cancel"
							color="white"
						/>
					</div>
					<div className="content">
						<div>
							<Label black>Name</Label>
							<Input length={15} required ref={(ref) => (this.myRefs.name = ref)} />
						</div>
						<div>
							<Label black>Location</Label>
							<Input className="location" ref={(ref) => (this.myRefs.location = ref)} />
						</div>
					</div>
					<Button color="white" bg="blue" onClick={this._save}>
						Save
					</Button>
					{/* <Button color="white" bg="red" onClick={this._close}>
						close
					</Button> */}
				</Card>
			</Popup>
		);
	}
}

export default class UnitListPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			units: [],
			creating: false,
			search: '',
			displayArchived: false
		};
		this.storageKey  = 'unitSortPreference';
		this.sortTableOptions = {
			loadSortConfig: () => {
				const item = localStorage.getItem(this.storageKey);
				if (item) return JSON.parse(item);
				return { key: 'Name', direction: 'asc' };
			},
			onSortConfigSet: ((config) => localStorage.setItem(this.storageKey, JSON.stringify(config)))
		}
	}

	componentDidMount = () => {
		this._getData();
		this.subscribeId = models.unit.onChange(this._getData);
	};

	componentWillUnMount = () => {
		models.unit.unsubscribe(this.subscribeId);
	};

	_getData = () => {
		let units = models.unit.objs();
		this.setState({ units });
	};

	_searchChange = (value) => {
		this.setState({ search: value });
	};

	_createUnit = () => {
		this.setState({ creating: true });
	}

	_hidePopup = () => {
		this.setState({ creating: false });
		setTimeout(() => {
			models.unit.refreshData().then();
		}, 1000);
	}

	getUnits = () => {
		const {search = '', units: unitPairs = {}, displayArchived = false} = this.state
		return Object.entries(unitPairs)
			.map(([_, unit]) => ({...unit, isArchived: models.unit.isArchived(unit)}))
			.filter(({isArchived}) => displayArchived || !isArchived)
			.map(({id: unitId, name, location, last_checked_by, last_checked_on, witness, isArchived}) => {
				const nameDisplay = isArchived ? (
					<>
						<div style={{display: 'inline-block', verticalAlign: 'middle', marginRight: '5px'}}>
							<Icon className="disabled icon" size="x-small" name="block"/>
						</div>
						<span style={{verticalAlign: 'middle'}}>{name}</span>
					</>
				) : <Link onClick={() => { history.navigate(`/unit/${unitId}`) }}>{name}</Link>

				// Setting default to Number.NEGATIVE_INFINITY ensure that invalid or empty dates
				// are sorted to the bottom when sorting descending so that you can sort descending
				// and see the most recent date at the top.
				const date = utils.server_to_client_date(last_checked_on);
				const lastCheckedValue = utils.is_date(date) ? date.getTime() : Number.NEGATIVE_INFINITY;
				const displayCheckedOnDate = utils.display_date(utils.server_to_client_datetime(last_checked_on))
				const checkedOnDisplay = (<>{displayCheckedOnDate}</>);

				return {
					data: [
						{column: "Name", value: name, children: nameDisplay},
						{column: "Location", value: location},
						{column: "Last Check By", value: last_checked_by},
						{
							column: "Last Checked",
							value: lastCheckedValue,
							children: checkedOnDisplay,
							searchValue: displayCheckedOnDate
						},
						{column: "Verified By", value: witness}
					],
				}
			})
			// Apply search filter based on the displayed values
			.filter(unit => {
				const {data = []} = unit
				const candidates = data.map(({value, searchValue}) => searchValue || value).filter(v => typeof v === 'string').map(v => v.toLowerCase())
				return candidates.some(candidate => candidate.includes(search.toLowerCase()))
			})
	}

	_renderCreatePopup = () => (<CreateUnitPopup creating={this.state.creating} onClose={this._hidePopup} />);

	_setDisplayArchived = ({target: {checked}}) => {
		this.setState({displayArchived: checked});
	}



	render() {
		return (
			<Page className="g-unit-list-page">
				<UpdateTitle newTitle="Units & Drug Boxes" originalTitle="LogRx" />
				{this._renderCreatePopup()}
				<Card className="body">
					<div className="top-row">
						<CardHeader>Units</CardHeader>
						<Input iconName="icon-search" placeholder="Search" onChange={this._searchChange} />
						<Button color="white" bg="blue large" onClick={this._createUnit}>
							Create
						</Button>
					</div>
					<ToggleSetting className='view-archived view-archived-units' labelPlacement='end' onChange={this._setDisplayArchived} />
					<SortableTable data={this.getUnits()} options={this.sortTableOptions} />
				</Card>
				<DrugBoxCard />
			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/unitListPage/UnitListPage.jsx